export const ApplicationModules = {
    CONTROL_TOWER: "CONTROL_TOWER",
    INSTANT_RATE: "INSTANT_QUOTE",
    INSTANT_BOOKING: "INSTANT_BOOKING",
    //SALES: "SALES", -- Not Rq
    CARRIER_RATES: "CARRIER_RATES",
    CUSTOMERS: "CUSTOMERS",
    SETTINGS: "SETTINGS",
    DASHBOARD: "DASHBOARD",
    //VENDOR_DASHBOARD: "VENDOR_DASHBOARD", -- not Rq
    INQUIRY: "INQUIRY",
    QUOTATION: "QUOTATION",
    AIR_FRIGHT: "AIR_FRIGHT",
    OCEAN_FRIGHT: "OCEAN_FRIGHT",
    CUSTOMER_RATES: "CUSTOMER_RATES",
    CUSTOMER_LIST: "CUSTOMER_LIST",
    CARRIER_MASTER: "CARRIER_MASTER",
    VENDOR: "VENDOR",
    SURCHARGE_MASTER: "SURCHARGE_MASTER",
    COMPANY_SETTINGS: "COMPANY_SETTINGS",
    UPLOAD_STATUS: "UPLOAD_STATUS",
    USER: "USER",
    INQUIRY_LIST: "INQUIRY_LIST",
    QUOTATION_LIST: "QUOTATION_LIST",
    REQUEST_FOR_RATE: "REQUEST_FOR_RATE",
    QUOTATION_APPROVAL: "QUOTATION_APPROVAL",

    MARKETPLACE_CONFIG: "FREIGHT_LEAD_PREFERENCE",
    INTEGRATION_CONFIG: "INTEGRATIONS",
    MARKETING: "MARKETING",
    INSTANT_QUOTE: "INSTANT_QUOTE",

    MY_INQUIRIES: "MY_INQUIRIES",
    FRIGHT_LEADS: "FRIGHT_LEADS",
    BOOKING_LEADS: "BOOKING_LEADS",
    CONTAINER_TRACKING: "CONTAINER_TRACKING",
    SAILING_SCHEDULE: "SHIPPING_SCHEDULE",
    AIR_CARGO_TRACKING: "AIR_CARGO_TRACKING",
    MY_BIDS: "MY_BIDS",
    SHIPPER_DASHBOARD: "INSIGHTS",
    MY_QUOTATIONS: "MY_QUOTATIONS",
    MARKET_PLACE_INQUIRY: "MARKET_PLACE_INQUIRY",
    MY_BOOKINGS: "MY_BOOKINGS",
    APPS: "APPS",
    AGENT_PERFERENCE: "AGENT_PERFERENCE"
};


export function hasControlTowerPermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.DASHBOARD,
        ApplicationModules.SHIPPER_DASHBOARD
    ]);
    return authUser.modulePermissions.some(obj => requiredModules.has(obj.moduleName)) || false;
}
export function hasBookingLeadsPermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.BOOKING_LEADS,
    ]);
    return authUser.modulePermissions.some(obj => requiredModules.has(obj.moduleName)) || false;
}
export function hasShipperDashboardPermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.SHIPPER_DASHBOARD,
    ]);
    return authUser.modulePermissions.some(obj => requiredModules.has(obj.moduleName)) || false;
}
export function hasDashboardPermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.DASHBOARD,
    ]);
    return authUser.modulePermissions.some(obj => requiredModules.has(obj.moduleName)) || false;
}
export function hasInstantPermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.INSTANT_QUOTE,
    ]);
    return authUser.modulePermissions.some(obj => requiredModules.has(obj.moduleName)) || false;
}

export function hasInstantBookingPermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.INSTANT_BOOKING,
    ]);
    return authUser.modulePermissions.some(obj => requiredModules.has(obj.moduleName)) || false;
}

export function hasInstantDomesticsRatePermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.INSTANT_RATE_DOMESTICS,
    ]);
    return authUser && authUser.modulePermissions && authUser.modulePermissions.some(obj => requiredModules.has(obj.moduleName)) || false;
}

export function hasInstantInternationalRatePermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.INSTANT_RATE_INTERNATIONAL,
    ]);
    return authUser && authUser.modulePermissions && authUser.modulePermissions.some(obj => requiredModules.has(obj.moduleName)) || false;
}
export function hasMyQuotationsPermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.MY_QUOTATIONS,
    ]);
    return authUser.modulePermissions.some(obj => requiredModules.has(obj.moduleName)) || false;
}
export function hasQuotationPermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.QUOTATION_LIST,
        ApplicationModules.QUOTATION_APPROVAL
    ]);
    return authUser.modulePermissions.some(obj => requiredModules.has(obj.moduleName)) || false;
}

export function hasQuotationListPermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.QUOTATION_LIST
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}
export function hasQuotationApprovalPermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.QUOTATION_APPROVAL,
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}

export function hasInquiryPermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.INQUIRY_LIST,
        ApplicationModules.REQUEST_FOR_RATE
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}

export function hasInquiryListPermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.INQUIRY_LIST
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}
export function hasInquiryRequestForRatePermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.REQUEST_FOR_RATE
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}

export function hasCarrierRatesPermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.OCEAN_FRIGHT,
        ApplicationModules.AIR_FRIGHT
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}
export function hasOceanFrightPermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.OCEAN_FRIGHT
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}
export function hasAirFrightPermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.AIR_FRIGHT
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}

export function hasCustomerPermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.CUSTOMER_LIST,
        ApplicationModules.CUSTOMER_RATES
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}
export function hasCustomerListPermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.CUSTOMER_LIST,
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}
export function hasCustomerRatesPermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.CUSTOMER_RATES,
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}

export function hasSettingPermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.COMPANY_SETTINGS,
        ApplicationModules.USER,
        ApplicationModules.SURCHARGE_MASTER,
        ApplicationModules.VENDOR,
        ApplicationModules.CARRIER_MASTER,
        ApplicationModules.UPLOAD_STATUS
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}

export function hasCompanySettingPermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.COMPANY_SETTINGS,
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}

export function hasMarketPlaceConfigPermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.MARKETPLACE_CONFIG,
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}

export function hasIntegrationsConfigPermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.INTEGRATION_CONFIG,
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}

export function hasUsersPermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.USER,
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}

export function hasSurchargeMasterPermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.SURCHARGE_MASTER,
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}

export function hasVendorPermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.VENDOR,
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}
export function hasCarrierMasterPermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.CARRIER_MASTER
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}
export function hasUploadStatusPermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.UPLOAD_STATUS
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}

export function hasMarketingPermission() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.MARKETING
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}

export function hasNetworkInquiries() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.MY_INQUIRIES,
        ApplicationModules.ACTIVE_INQUIRIES,
        ApplicationModules.MY_BIDS,
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}

export function hasMyInquiries() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.MY_INQUIRIES
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}

export function hasMyBookings() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.MY_BOOKINGS
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}

export function hasActiveInquiries() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.FRIGHT_LEADS
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}

export function hasTools() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.CONTAINER_TRACKING,
        ApplicationModules.SAILING_SCHEDULE,
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}

export function hasContainerTracking() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.CONTAINER_TRACKING
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}

export function hasSailingSchedule() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.SAILING_SCHEDULE
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}

export function hasAirCargoTracking() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.AIR_CARGO_TRACKING,
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}

export function hasMyBids() {
    const authUser = JSON.parse(localStorage.getItem("authUser"));
    const requiredModules = new Set([
        ApplicationModules.MY_BIDS
    ]);
    return authUser?.modulePermissions?.some(obj => requiredModules.has(obj.moduleName)) || false;
}
